import { matchPath, useLocation } from 'react-router';

import { ROUTES } from '@/constants';

import type { RouteScope } from './types';

/**
 * The region and season the URL points at.
 *
 * Matched against the pathname rather than read with `useParams`, because
 * `AppProvider` renders above `<Routes>` and so has no route match of its own.
 * `end: false` matches the scope prefix of every page underneath it.
 */
const useRouteScope = (): RouteScope => {
  const { pathname } = useLocation();

  const match = matchPath({ path: ROUTES.APP, end: false }, pathname);

  return {
    regionId: match?.params.region,
    seasonId: match?.params.season
  };
};

export default useRouteScope;
